import axios from 'axios';
import { auth, login, renew } from './httpService/user/index.js';

const clearLocalStorage = () => {
    localStorage.removeItem("selectedAthlete");
    localStorage.removeItem("selectedCalenderWeek");
    localStorage.removeItem("selectedTab");
    localStorage.removeItem("openWeeklySchedule_mobile");
    localStorage.removeItem("selectedViewAthletesTab");
    localStorage.removeItem("trainingSessions");
    localStorage.removeItem("trainingSessions_athlete");
}

export const doLogin = (email, password) => {
    const loginData = {
        email: email,
        password: password
    };

    login(loginData)
        .then(response => {
            if (response.data.success) {
                const token = response.data.token;
                localStorage.setItem("token", token);
                setAuthToken(token);
                clearLocalStorage();
                window.location.href = '/'
            }
        })
        .catch(() => {
        });
}

export const doLogout = () => {
    setAuthToken();
    localStorage.removeItem("token");
    clearLocalStorage();
    window.location.href = '/';
}

export const loadToken = () => {
    const token = localStorage.getItem("token");
    if (token) {
        setAuthToken(token);
    }
    return token;
}

export const verifyToken = (token) => {
    const authData = {
        token: token
    };
    return auth(authData);
}

export const setAuthToken = token => {
    if (token) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else
        delete axios.defaults.headers.common["Authorization"];
}

// Manueller JWT Decode
const decodeToken = (token) => {
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return JSON.parse(jsonPayload);
    } catch {
        return null;
    }
}

export const getTokenTimeLeft = (token) => {
    const decoded = decodeToken(token);
    if (!decoded || !decoded.exp) return 0;
    const expirationTime = decoded.exp * 1000; // Convert to milliseconds
    const timeLeft = Math.max(0, Math.floor((expirationTime - Date.now()) / 1000));
    return timeLeft;
}

export const renewToken = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
        doLogout();
        return false;
    }

    try {
        const response = await renew({ token });
        if (response.data.success) {
            const newToken = response.data.token;
            localStorage.setItem("token", newToken);
            setAuthToken(newToken);
            return true;
        }
    } catch (err) {
        console.error("Token renewal failed:", err);
        return false;
    }
}